import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 1440px;
  min-height: calc(100vh - 129px);
  margin: 0 auto;
  padding: 0 60px;
`;
